export type TicketStatus = 'open' | 'in_progress' | 'resolved' | 'closed';

export const TICKET_STATUS_BADGE: Record<TicketStatus, string> = {
  open: 'bg-blue-900/40 text-blue-300',
  in_progress: 'bg-amber-900/40 text-amber-300',
  resolved: 'bg-green-900/40 text-green-300',
  closed: 'bg-slate-700 text-slate-400',
};

export interface SupportTicket {
  id: number;
  user_id: number;
  user_email?: string;
  subject: string;
  status: TicketStatus;
  created_at: string;
  updated_at: string;
}

export interface TicketMessage {
  id: number;
  ticket_id: number;
  sender_user_id: number;
  body: string;
  is_admin: boolean;
  created_at: string;
}

export interface TicketDetail {
  ticket: SupportTicket;
  messages: TicketMessage[];
}
